import DeviceInfo from "react-native-device-info";
import { IDFA } from "@lib/idfa";
import { getCurrentLocation } from "@utils/getCurrentLocation";

const getLocationAndIdentifers = async () => {
  const data = {
    idfa: null,
    lat: null,
    lng: null,
    unique_device_id: null,
  };

  try {
    const [idfaData, locationData, unique_device_id] = await Promise.all([
      IDFA.getIDFA(),
      getCurrentLocation(),
      DeviceInfo.getUniqueId(),
    ]);

    const { latitude: lat, longitude: lng } = locationData?.coords || {};

    data.idfa = idfaData;
    data.lat = lat;
    data.lng = lng;
    data.unique_device_id = unique_device_id;
  } catch (error) {
    console.error("Error in fetching data: ", error);
  }

  return data;
};

export default getLocationAndIdentifers;
